import { Button, Link } from '@mui/material';

/**
 * It's a button that looks like a link!
 */
export default function LinkButton({ children, sx = {}, ...props }) {
  return (
    <Link
      component={Button}
      {...props}
      sx={{
        textDecoration: 'underline',
        textTransform: 'none',
        fontSize: '1rem',
        fontWeight: 'normal',
        padding: 0,
        '&:focus-visible': {
          outline: '1px solid',
        },
        minWidth: '',
        ...sx,
      }}
    >
      {children}
    </Link>
  );
}
